import { OrderSide, type Position } from '@/types/generated/common/trading'

export function groupOptionPositionsBySymbol(positions: Position[]): Map<string, Position[]> {
  const grouped = new Map<string, Position[]>()

  for (const position of positions) {
    const existing = grouped.get(position.symbol)
    if (existing) {
      existing.push(position)
    } else {
      grouped.set(position.symbol, [position])
    }
  }

  return grouped
}

export interface OptionPositionExposure {
  long: number
  short: number
  details: Array<{
    accountId: string
    side: 'long' | 'short'
    size: number
  }>
}

export function summarizeOptionPositions(
  positions: Position[],
  contractSize?: number
): OptionPositionExposure {
  const divisor = contractSize && contractSize > 0 ? contractSize : 1
  const result: OptionPositionExposure = {
    long: 0,
    short: 0,
    details: [],
  }

  for (const position of positions) {
    const quantity = Math.abs(Number(position.quantity))
    if (!Number.isFinite(quantity)) continue
    const size = quantity / divisor
    const side =
      position.side === OrderSide.ORDER_SIDE_BUY ||
      Number(position.side) === OrderSide.ORDER_SIDE_BUY
        ? 'long'
        : 'short'

    result[side] += size
    result.details.push({ accountId: position.accountId, side, size })
  }

  return result
}
